import { SensitiveData } from '@philips-internal/oswald-ui-constants';
const HIDDEN_VALUE_CHAR = '•';
const HIDDEN_CHAR_REPLACER = /[^\s]/gi;
function hideSensitiveData(text, sensitiveData, options = {}) {
    if (sensitiveData === SensitiveData.NONE) {
        return text;
    }
    if (sensitiveData === SensitiveData.HIDDEN) {
        return HIDDEN_VALUE_CHAR.repeat(5);
    }
    if (text.length < 5) {
        return HIDDEN_VALUE_CHAR.repeat(text.length);
    }
    const textTwentyPercentLength = Math.ceil(text.length * .2);
    const numberOfHiddenChars = text.length - Math.min(4, textTwentyPercentLength);
    const replacer = options.replacer ?? HIDDEN_CHAR_REPLACER;
    return text.slice(0, numberOfHiddenChars).replaceAll(replacer, HIDDEN_VALUE_CHAR) + text.slice(numberOfHiddenChars);
}
export { HIDDEN_VALUE_CHAR, hideSensitiveData, };
//# sourceMappingURL=hide-sensitive-data.js.map